import * as React from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers';
import enLocale from 'date-fns/locale/en-GB';
import frLocale from 'date-fns/locale/fr';
import { SnackbarProvider } from 'notistack';
//import { ConfirmationServiceProvider } from 'src/components/ConfirmDialog';
import { useSettings } from 'src/context/SettingsContext';
import { createTheme } from 'src/theme';
//import { ApiProvider } from './ApiContext';
import { LoadingScreenProvider } from './LoadingScreenContext';
import { createContext, useState } from 'react';
import { MenuItem } from '../interfaces/menuItem';
import { User } from '../interfaces/user';
import { MENU } from '../constants/menu';
import config from 'src/config';

export const localeMap: { [key: string]: any } = {
  en_UK: enLocale,
  fr_FR: frLocale,
};

/*class FrLocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText(date: number | Date) {
    return format(date, 'd MMM yyyy', { locale: this.locale });
  }
}*/

/*const localeUtilsMap: { [key: string]: any } = {
  en_UK: DateFnsUtils,
  fr_FR: FrLocalizedUtils,
  fr: FrLocalizedUtils,
};*/

interface AppProviderInterface {
  menu: MenuItem;
  setMenu: (menu: MenuItem) => void;
  user: User;
  setUser: (user: User) => void;
}

export const AppContext = createContext<AppProviderInterface>({
  menu: {},
  setMenu: () => {},
  user: {},
  setUser: () => {},
});

const AppProviders = ({ children }: { children?: React.ReactNode }) => {
  const { settings } = useSettings();
  const [menu, setMenu] = useState<MenuItem>(MENU);
  const [user, setUser] = useState<User>({});

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={createTheme(settings)}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          // utils={
          //   localeUtilsMap[settings.locale] ||
          //   localeUtilsMap[config.app.defaultLang]
          // }
          adapterLocale={
            localeMap[settings.locale] || localeMap[config.app.defaultLang]
          }>
          <LoadingScreenProvider>
            <SnackbarProvider maxSnack={6}>
              <AppContext.Provider
                value={{
                  ...{
                    menu,
                    setMenu,
                    user,
                    setUser,
                  },
                }}>
                {/*<ConfirmationServiceProvider>*/}
                {children}
                {/*</ConfirmationServiceProvider>*/}
              </AppContext.Provider>
            </SnackbarProvider>
          </LoadingScreenProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export { AppProviders };
